class APIS {
    apis() {
        return {
            fetch: {
                headers: {
                    'xt-user-token': null,
                },
                method: 'post',
                path: '/get/ips',
            },
            add: {
                headers: {
                    'xt-user-token': null,
                },
                method: 'post',
                path: '/ip/add',
            },
            update: {
                headers: {
                    'xt-user-token': null,
                },
                method: 'post',
                path: '/ip/update',
            },
            delete: {
                headers: {
                    'xt-user-token': null,
                },
                method: 'post',
                path: '/ip/delete',
            },
        };
    }
}

export default new APIS();
